import React, { useContext, useState, Suspense, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { APP_CONTROLLER_ACTIONS } from "../constants/actionTypes.js";
import { useAppStateController } from "../store/appStateController";
import { appContext } from "../states/context/appContext";
import "./RoutesComponent.css";

const SidebarComponent = React.lazy(() =>
  import("../components/SidebarComponent")
);
const HeaderComponent = React.lazy(() =>
  import("../components/HeaderComponent")
);
const SupplierDelay = React.lazy(() =>
  import("../components/SupplierDelayComponent")
);
const ReportGenerator = React.lazy(() =>
  import("../components/ReportGeneratorComponent")
);
const IntelliegencePage = React.lazy(() => import("./IntelligenceIndex"));

const MilestoneTrackerIndex = React.lazy(() =>
  import("./milestoneTracker/milestoneTrackerIndex")
);
const SrmIndex = React.lazy(() => import("./srm/srmIndex"));
const SupplierDatabaseIndex = React.lazy(() =>
  import("./supplierDatabase/supplierDatabaseIndex")
);
const DocumentPdfViewer = React.lazy(() =>
  import("../components/milestoneTracker/DocumentPdfViewer")
);
const ChoosePlan = React.lazy(() => import("../components/ChoosePlan"));
const CopilotComponent = React.lazy(() =>
  import("../components/kavidaCopilot/CopilotComponent")
);

const RoutesComponent = (props) => {
  const globalContext = useContext(appContext);
  const location = useLocation();
  
  // DIRECT REDUX: Critical data source using direct Redux appStateController
  const dispatchAction = useAppStateController();
  
  const [routes, setRoutes] = useState([]);

  React.useEffect(() => {
    (async () => {
      try {
        const { meta, data } = props.getTemplateApiData;
        if (meta?.message === "Success") {
          const { users } = data[0];
          globalContext.setRegion({...globalContext.region, regionOptions: users?.region_options});
          globalContext.setExCountryLabel(users?.ex_country_label);
          globalContext.setExFactoryLabel(users?.ex_factory_label);
          dispatchAction({
            action: APP_CONTROLLER_ACTIONS.GET_USER,
            payload: users || {},
          });
          dispatchAction({
            action: APP_CONTROLLER_ACTIONS.UPDATE_MENU,
            payload: users.ui_template || {},
          });
          globalContext.setShowDeliverySlot(users.delivery_slot);
          globalContext.setShowDummyPo(users.show_dummy_po);
          const { email_integration_button, email_integration_status, show_refresh_button } = users;
          globalContext.setShowEmailIntegrationButton(email_integration_button);
          globalContext.setEmailIntegrationStatus(email_integration_status);
          globalContext.setShowRefreshButton(show_refresh_button);
          let uiTemplate = users.ui_template;
          let temp = {
            layout: "/kavida",
            component: "GettingStarted",
            icon: "",
            name: "Getting Started",
            path: "/getting-started",
            tabs: [],
          };
          let temp2 = {
            layout: "/kavida",
            component: "ChoosePlan",
            icon: "",
            name: "Choose the best plan for you",
            path: "/choose-plan",
            tabs: [],
          };
          let temp1 = [...uiTemplate];
          temp1.push(temp);
          temp1.push(temp2);
          setRoutes(temp1);
          globalContext.setSelectedMenu({
            name: users.ui_template[0].name,
          });
          return getRoutes();
        } else {
          setRoutes([]);
        }
      } catch (e) {
        console.error('[RoutesComponent] useEffect error processing getTemplateApiData:', e, '| getTemplateApiData =', props.getTemplateApiData);
      }
    })();
  }, []);

  useEffect(() => {
    if(location.pathname.includes("/kavida/copilot")){
      globalContext.setShowHeader(false);
    } else {
      globalContext.setShowHeader(true);
    }
  }, [location.pathname]);

  const getRoutes = () => {
    if (
      location.pathname !== "/kavida/supplier-delays" &&
      location.pathname !== "/kavida/commodity-risks"
    )
      return routes.map((prop, key) => {
        if (prop.layout === "/kavida") {
          if (prop.component === "Intelligence")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<IntelliegencePage />}
                key={key}
              />
            );
          if (prop.component === "ChoosePlan")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<ChoosePlan />}
                key={key}
              />
            );
          if (prop.component === "Finder") {
            const basePath = `${prop.layout}${prop.path}`;
            // Handle both finder and doc-viewer routes
            if (location.pathname.includes("/doc-viewer")) {
              return <Route path={`${basePath}/doc-viewer`} element={<DocumentPdfViewer />} key={key} />;
            } else {
              return <Route path={basePath} element={<MilestoneTrackerIndex />} key={key} />;
            }
          }
          if (prop.component === "SRM")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<SrmIndex />}
                key={key}
              />
            );
          if (prop.component === "SupplierDatabase")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<SupplierDatabaseIndex />}
                key={key}
              />
            );
          if (prop.component === "ActionItems")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "Chats")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "Insights")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "MyAgents")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "Team")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "AutomationLibrary")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "Community")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "Support")
            return (
              <Route
                path={prop.layout + prop.path}
                element={<CopilotComponent />}
                key={key}
              />
            );
          if (prop.component === "ReportGenerator") {
            const path = `${prop.layout}${prop.path}`;
            let RouteComponent = ReportGenerator; // default for control tower
            
            // Check if we are in the order-book/finder path
            if (location.pathname.includes("/kavida/order-book/finder")) {
              if (location.pathname.includes("/kavida/order-book/finder/doc-viewer")) {
                // Return specific route for doc-viewer
                return <Route path="/kavida/order-book/finder/doc-viewer" element={<DocumentPdfViewer />} key={key} />;
              } else {
                // Return specific route for finder
                return <Route path="/kavida/order-book/finder" element={<MilestoneTrackerIndex />} key={key} />;
              }
            }
         
            return <Route path={path} element={<RouteComponent />} key={key} />;
          }
        } else {
          return null;
        }
      });
      
    // Add specific routes for order-book/finder if not already handled
    if (location.pathname.includes("/kavida/order-book/finder/doc-viewer")) {
      return <Route path="/kavida/order-book/finder/doc-viewer" element={<DocumentPdfViewer />} />;
    }
    if (location.pathname.includes("/kavida/order-book/finder")) {
      return <Route path="/kavida/order-book/finder" element={<MilestoneTrackerIndex />} />;
    }
    
    else if (location.pathname === "/kavida/supplier-delays")
      return <Route element={<SupplierDelay />} />;
  };

  const getHeaderTitle = (path, name) => {
    if (path.includes("/copilot") || path.includes("/command-tower")) {
      return "";
    } else {
      return <h1 className="componentHeading">{name}</h1>;
    }
  };

  return (
    <div>
      <Suspense fallback={<></>}>
        {globalContext.showHeader ? <HeaderComponent /> : null}
      </Suspense>
      <div>
        <div>
          <Suspense fallback={<></>}>
            <SidebarComponent
              routes={routes}
              selectedMenu={globalContext.selectedMenu}
              emailIntegration={{
                button: globalContext.showEmailIntegrationButton,
                status: globalContext.emailIntegrationStatus,
              }}
            />
          </Suspense>
        </div>
        <div
          className={!globalContext.showHeader ? "routesContainer no-header" : `routesContainer`}
          style={
            location.pathname.includes("/kavida/copilot")
              ? { paddingLeft: "48px" }
              : {}
          }
        >
          {location.pathname !== "/kavida/getting-started" ? (
            routes.length &&
            routes.map((route) => {
              if (
                location.pathname.indexOf(route.layout + route.path) !==
                -1
              ) {
                return getHeaderTitle(route.path, route.name);
              }
            })
          ) : (
            <div className="user-guide-heading">
              <h1>Get to know Kavida</h1>
            </div>
          )}
          <Suspense
            fallback={
              <div className="fixed-loading-container">
                <CircularProgress aria-label="Loading application" />
              </div>
            }
          >
            <Routes>
              {/* Add specific routes for order-book paths */}
              <Route path="/kavida/order-book/finder/doc-viewer" element={<DocumentPdfViewer />} />
              <Route path="/kavida/order-book/finder" element={<MilestoneTrackerIndex />} />
              {getRoutes(routes)}
            </Routes>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default RoutesComponent;
